<template>
    <div id="app">
        <a-config-provider :locale="zh_CN">
            <router-view />
        </a-config-provider>
    </div>
</template>

<script>
import zh_CN from 'ant-design-vue/lib/locale-provider/zh_CN';
export default {
    data() {
        return {
            zh_CN
        };
    }
};
</script>

<style>
ul {
    margin: 0;
    padding: 0;
}
li {
    list-style: none;
}
.ant-layout.page_layout,
.ant-layout .page_content.single {
    padding: 30px;
}
.ant-layout .page_content {
    max-height: calc(100vh - 175px);
    overflow: hidden;
    overflow-y: auto;
}
/* .ant-layout .page_content.scroll {
    max-height: calc(100vh - 227px);
    overflow: auto;
} */
.ant-layout .page_header,
.ant-layout .page_content,
.ant-layout .page_footer {
    background: #fff;
    padding-left: 30px;
    padding-right: 30px;
    position: relative;
}
.ant-layout.component_layout {
    background: #fff;
}
.ant-layout .component_header,
.ant-layout .component_content,
.ant-layout .component_footer {
    background: #fff;
    padding-left: 0;
    padding-right: 0;
    position: relative;
}
.ant-layout .ant-btn-group {
    margin-left: -7px;
    align-items: center;
}
</style>
